import { Dimension, Units, convert, toUnits } from "../organisms/Dimensions";
import { defaultTranslations, formatDimensions } from "../organisms/DimensionsText";
import { IVerticalPricingCalculatorTranslations } from "../types";

const reMatcher = /{{.*?\}}/g;

export interface Indexable {
  [key: string]: string;
}

function trFactory(translations: Indexable) {
  return (k: string, vs?: Record<string, any>) => {
    const txt = translations[k] || `"${k}" not provided`;
    const matches = [...txt.matchAll(reMatcher)];

    return matches.reduce((s, cur) => {
      const trimmedKey = cur[0].replace("{{", "").replace("}}", "");

      return s.replace(cur[0], (vs && vs[trimmedKey]) || "?");
    }, txt);
  };
}

export const trPricingCalculator =
  (
    tr: (k: string, params?: Record<string, string>) => string,
    opts: {
      width: number;
      height: number;
      moq: number;
      units: Units;
      minDimensions: Dimension;
      maxDimensions: Dimension;
    }
  ) =>
  (k: keyof IVerticalPricingCalculatorTranslations) => {
    const { width, height, units } = opts;

    const displayAs = units;

    return tr(k, {
      units: units === "cm" ? tr("cm") : tr("in"),
      width: toUnits(units, width),
      height: toUnits(units, height),
      minWidth: toUnits(
        displayAs,
        convert(opts.minDimensions.unit, displayAs, opts.minDimensions.width)
      ),
      maxWidth: toUnits(
        displayAs,
        convert(opts.maxDimensions.unit, displayAs, opts.maxDimensions.width)
      ),
      minHeight: toUnits(
        displayAs,
        convert(opts.minDimensions.unit, displayAs, opts.minDimensions.height)
      ),

      maxHeight: toUnits(
        displayAs,
        convert(opts.maxDimensions.unit, displayAs, opts.maxDimensions.height)
      ),
      dimensions: formatDimensions({
        width,
        height,
        units,
        translations: defaultTranslations,
      }),
      moq: opts.moq.toString(),
    });
  };

export default trFactory;
